if (!customElements.get('audrey-cart-countdown')) {
  const deadline = Date.now() + 30 * 60 * 1000;
  customElements.define('audrey-cart-countdown', class extends HTMLElement {
    connectedCallback() {
      const update = () => {
        const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        this.textContent = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
        if (!seconds) clearInterval(this.timer);
      };
      this.timer = setInterval(update, 1000);
      update();
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}
